module.exports = __webpack_public_path__ + "img/AF.983c87e6.png";